<template>
    <div class="trafficRoute">
        <p class="road_title" @click="direction(num)" >
           {{traffic_route.name}}
            <span class="direction" :class="{moveDown:isActive,moveUp:hasError}">
                <img src="../../assets/images/service/direction.png" alt="">
            </span>
        </p>
        <transition name="slide-fade">
            <div class="route_of_enquiry" style="white-space:pre-wrap" v-if="isShow" v-html="htmlDecode(traffic_route.content)"></div>
        </transition>
    </div>
</template>
<script>
    export default {
        name: "trafficRoute",
        props:['traffic_route'],
        data: function () {
            return {
                num :0,
                isActive:false,
                hasError:false,
                isShow:false
            }
        },
        methods:{
            direction :function (n) {
                n ++ ;
                console.log(n);
                this.num = n;
                if(n%2 =='1'){
                    this.isActive = true;
                    this.hasError = false;
                    this.isShow = true;
                }
                else {
                    this.isActive = false;
                    this.hasError = true;
                    this.isShow = false;
                }

            },
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/direction";

    .trafficRoute {
        width: @width;
        font-size: .9rem;
        margin-bottom: 10px;
        .road_title {
            color: @brick_red;
            line-height: 30px;
            width: @width;
            margin-bottom: 5px;
            .direction {
                float: right;
                width: 20px;
                height: 30px;
                margin-top: 5px;
                img {
                    width: 8px;
                }
            }
        }
        .route_of_enquiry {
            .box-sizing;
            padding: 8px;
            .border(1px; dashed; @brick_red);
            .border-radius(10px);
            line-height: 20px;
        }

    }
    @media (min-width: 768px) and (orientation: portrait){
        .trafficRoute {
            font-size: 1rem;
            .road_title {
                .direction {
                    img {
                        width: 10px;
                    }
                }
            }

        }
    }

</style>
